import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class AppReadyService {
  private _appReady$ = new BehaviorSubject<boolean>(false);
  appReady$ = this._appReady$.asObservable();

  markAppAsReady() {
    this._appReady$.next(true);
  }

  isReady(): boolean {
    return this._appReady$.getValue();
  }
}
